import React from 'react'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { PsqlTableProvider } from 'common/components/PsqlTable/psql_table_provider'
import { PersistentFiltersProvider } from 'common/contexts/persistent_filters'

import { useVendorStores } from 'vendor/hooks/use-stores'
import { columnsFactory } from 'vendor/pages/Private/@v2/OrderMaterials/factories/columns_factory'
import { OrdersMaterialsContent } from 'vendor/pages/Private/@v2/OrderMaterials/order_materials_content'

function Content() {
  const { orderMaterialStore, notificationStore } = useVendorStores()

  const columns = columnsFactory({
    statusColumn: {
      getNotificationsCount: (id) => notificationStore.notificationsCountByOrder(id),
    },
  })

  return (
    <PersistentFiltersProvider
      ignoreOnFilterCounter={['order_state', 'customer_name']}
      listStore={orderMaterialStore.listStore}
    >
      <PsqlTableProvider
        options={{
          data: toJS(orderMaterialStore.listStore.records),
          sort: {
            sortFromPersistentFilter: true,
            field: orderMaterialStore.listStore.searchState.sort,
            direction: orderMaterialStore.listStore.searchState.sort_direction,
          },
          columns: columns,
        }}
        tableName="AllOrdersMaterials"
      >
        <OrdersMaterialsContent />
      </PsqlTableProvider>
    </PersistentFiltersProvider>
  )
}

export const VendorOrderMaterialPageV2 = observer(Content)
